export default __webpack_public_path__ + "media/images/ui-icons_ffd27a_256x240-b1395d7a2a3288a98f8228e1ef360ec8.png";